<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-body">
                <form [formGroup]="LocationCreationForm" (ngSubmit)="SaveLocation()">
                    <mat-card class="btnCard">
                        <button type="submit" *ngIf="_global.IsAdmin || IsSecondaryOwner==false"
                            mat-stroked-button>{{btnValue}}</button>
                        <button type="button" *ngIf="_global.IsAuditVisible" mat-stroked-button
                            (click)="openAuditTrailDialog()" style="display: none">Audit Trail</button>
                        <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
                    </mat-card>
                    <fieldset>
                        <div class="panel panel-default">
                            <header class="panel-heading">
                                <h5 class="panel-title">Location Master</h5>
                            </header>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label class="required">Location Name</label>
                                        <p-dropdown [options]="locationList" placeholder="--Select Location Name--"
                                          formControlName="LocationID" filter="true" (onChange)="LoadLocationMasterdataByID();">
                                        </p-dropdown>
                                        <mat-error
                                            *ngIf="GetFormControls('LocationID').invalid && (GetFormControls('LocationID').dirty || GetFormControls('LocationID').touched)"
                                            class="ValidationError">
                                            <mat-error *ngIf="GetFormControls('LocationID').errors.required">
                                                Location name is required.
                                            </mat-error>
                                        </mat-error>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="required">Location Spoc Name</label>
                                        <p-autoComplete appPreventSpecialChars formControlName="SecondaryZoneHead" [suggestions]="employeeList"
                                            (completeMethod)="SearchActiveEmployee($event)" placeholder="search name"  
                                            field="EmployeeName" [forceSelection]="true" [minLength]="3"
                                            (onSelect)="SetSecondaryEmployeeDetails($event)"
                                            (onClear)="clearAutoComplete('SecondaryZoneHead')" >
                                        </p-autoComplete>
                                    </div>
                                    <div class="form-group col-md-4 secondarybutton">
                                        <button type="button" mat-stroked-button 
                                            (click)="addItem()">Add to List</button>
                                    </div>
                                                                            <!-- *ngIf="_global.SecondaryHeadBtnVisible" -->

                                </div><br><br>
                                <mat-card class="mat-border">
                                    <div class="container">
                                        <div class="row">                                            
                                            <div class="form-group col-md-3">
                                                <label>Spoc Name</label>
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label>Email</label>
                                            </div>
                                            <div class="form-group col-md-3">
                                                <label>Phone</label>
                                            </div><div class="form-group col-md-2 rmv-btn">
                                                <label>Action</label>
                                            </div>
                                        </div>
                                        <div formArrayName="SecondaryHeadForm"
                                            *ngFor="let item of LocationCreationForm.get('SecondaryHeadForm')['controls']; let i = index;">
                                            <div [formGroupName]="i">
                                                <div class="row" *ngIf="item.controls.IsActive.value">                                                   
                                                    <div class="form-group col-md-3">
                                                        <input class="form-control" formControlName="SecondaryHeadName"
                                                            placeholder="Spoc Name" readonly appPreventSpecialChars>
                                                    </div>
                                                    <div class="form-group col-md-3">
                                                        <input class="form-control" formControlName="SecondaryHeadEmail"
                                                            placeholder="Email" readonly>
                                                    </div>
                                                    <div class="form-group col-md-3">
                                                        <input class="form-control" formControlName="SecondaryHeadCUG"
                                                            placeholder="Phone" readonly>
                                                    </div>
                                                    <div class="form-group col-md-2 rmv-btn">
                                                        <button type="button" mat-stroked-button
                                                            (click)="removeItem(LocationCreationForm.controls.SecondaryHeadForm, i)">Remove</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-top: 45px; padding-left: 75px;"
                                            *ngIf="LocationCreationForm.get('SecondaryHeadForm')['controls'].length==0">
                                            <div class="form-group col-md-3">
                                                No Records found!
                                            </div>
                                        </div>
                                    </div>
                                </mat-card>

                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </section>
</div>